import { Link } from 'react-router-dom';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { SiteHeader } from '../../components/SiteHeader';
import { FooterSection } from '../../components/FooterSection';
import './SuccessPage.css';

export function SuccessPage() {
  useDocumentTitle('Payment Successful');

  return (
    <div className="landing success-page">
      <SiteHeader />

      <main className="success-page__main">
        <div className="container success-page__content">
          <div className="success-page__icon" aria-hidden="true">
            <svg viewBox="0 0 48 48" width="48" height="48">
              <circle cx="24" cy="24" r="24" fill="#dcfce7" />
              <path
                fill="#16a34a"
                d="M34 17.5 21.25 30.25 14 23l1.5-1.5 5.75 5.75L32.5 16l1.5 1.5z"
              />
            </svg>
          </div>
          <h1>Your payment is successful</h1>
          <p className="success-page__message">
            Thank you for subscribing to Review Lumen. We&apos;ve received your
            payment and your account is being set up. You&apos;ll receive a
            confirmation email shortly with next steps.
          </p>
          <p className="success-page__back">
            <Link to="/">← Back to home</Link>
          </p>
        </div>
      </main>

      <FooterSection />
    </div>
  );
}
